import { FLEX_FINALIZE_PARENT_PATH, makePath } from 'shared';
function getPathWithToken(routePath, token, extraParams) {
    const basePath = makePath(FLEX_FINALIZE_PARENT_PATH, routePath);
    const params = new URLSearchParams();
    if (token)
        params.set('token', token);
    Object.entries(extraParams ?? {}).forEach(([key, value]) => params.set(key, value));
    const search = params.toString();
    return search ? `${basePath}?${search}` : basePath;
}
export default getPathWithToken;
